// extracted by mini-css-extract-plugin
module.exports = {"Component":"Input_Component__1E23m"};